window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');


    require('../../public/vendor/overlayscrollbars/js/Overlayscrollbars');
    require('../../public/vendor/adminlte/dist/js/adminlte');

    //require('../../public/vendor/pace-progress/pace.js');
    window.Swal = require('sweetalert2');

    window.bsCustomFileInput = require ('../../public/vendor/bs-custom-file-input/bs-custom-file-input.js')

    require('../../public/vendor/jquery-validation/jquery.validate.js');

    window.toastr = require('../../public/vendor/toastr/toastr.min.js');

    require('../../public/vendor/select2/js/select2.js');

    require('bootstrap4-toggle');

    require('../../packages/atplus/atcore8/src/assets/js/atcore.js');
    require('../../packages/atplus/atcore8/src/assets/js/holdOn/HoldOn.min.js');


    window.moment = require('moment');

    require('../../public/vendor/daterangepicker/daterangepicker.js');

    require('../../public/vendor/inputmask/inputmask.min.js')
    require('../../public/vendor/inputmask/bindings/inputmask.binding.js')

    window.onScan = require('onscan.js');

    window.Chart = require('chart.js/auto').default;

    window.pos = require('transbank-pos-sdk-web');

    require('print-js');

    //require('@fancyapps/fancybox');
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.Vue = require('vue');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
